// src/register-lazy.ts
var PENDING_KEY = "__norkron_conformance_pending__";
function registerLazy(libId, thunk) {
  const g = globalThis;
  let p = g[PENDING_KEY];
  if (!p) {
    p = [];
    g[PENDING_KEY] = p;
  }
  p.push({ libId, thunk });
}

export { registerLazy };
//# sourceMappingURL=register-lazy.js.map
//# sourceMappingURL=register-lazy.js.map